import { ApiClient } from 'lib/api/ApiClient.types';
import { parseWithDecoratedError } from 'v4/entities/common/parseWithDecoratedError';
import {
  BookingWithVendorStatesListResponse,
  BookingWithVendorStatesQuery,
  ManualSyncResponse,
  VisitorVendorStateApi,
  VisitorVendorStateListResponse,
  VisitorVendorStateQuery
} from './visitor-vendor-state.api';
import {
  bookingWithVendorStatesListResponse$,
  manualSyncResponse$,
  visitorVendorStateListResponse$
} from './visitor-vendor-state.api.http.schema';

export function createVisitorVendorStateApi(
  client: ApiClient
): VisitorVendorStateApi {
  return {
    async list(
      query: VisitorVendorStateQuery
    ): Promise<VisitorVendorStateListResponse> {
      const response = await client.get(`/visitor_vendor_state`, {
        params: query.filters,
        team: query.schema,
        token: true
      });

      return parseWithDecoratedError(visitorVendorStateListResponse$, response);
    },

    async listWithBookingDetails(
      query: BookingWithVendorStatesQuery
    ): Promise<BookingWithVendorStatesListResponse> {
      const response = await client.get(
        `/visitor_vendor_state/with-booking-details`,
        {
          params: query.filters,
          team: query.schema,
          token: true
        }
      );

      return parseWithDecoratedError(
        bookingWithVendorStatesListResponse$,
        response
      );
    },

    async manualSync(
      schema: string,
      bookingId: number
    ): Promise<ManualSyncResponse> {
      const response = await client.post(
        `/visitor_vendor_state/sync/${bookingId}`,
        {
          team: schema,
          token: true
        }
      );

      return parseWithDecoratedError(manualSyncResponse$, response);
    }
  };
}
